import {Component, OnInit} from '@angular/core';
import {OrderModel} from '../../../../models/order.model';
import {OrderService} from '../../../../services/order.service';
import {first} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-order-receipt',
  templateUrl: './order-receipt.component.html',
  styleUrls: ['./order-receipt.component.scss']
})
export class OrderReceiptComponent implements OnInit {
  showLoader: boolean = true;
  order: OrderModel;
  totalDiscount: number = 0;

  constructor(private activated: ActivatedRoute,
              private orderService: OrderService,
              private router: Router) {
    this.activated.params.pipe(first()).toPromise()
      .then(params => {
        this.orderService.getOrderInfo(params['id'])
          .subscribe(order => {
            this.order = order;
            this.showLoader = false;
            if (order.discounts) {
              _.forEach(order.discounts, (discount) => {
                this.totalDiscount += discount.amount;
              });
            }
          });
      });
  }

  ngOnInit() {
  }

  goBack() {
    history.back();
  }

}
